import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Tabs from "./Tabs";

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren, extra) {
    var props, childrenNode, reactifiedChildren;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props = {
              analytics: extra.analytics,
              defaultTab: domNode.getAttribute("data-default-tab"),
              isRehydrating: true,
              layoutVariant: domNode.getAttribute("data-layout-variant") || null,
              horizontalTabsActions: domNode.getAttribute("data-horizontal-tabs-actions") || null
            };
            childrenNode = domNode.querySelector(domNode.getAttribute("data-rehydratable-children-selector"));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Tabs, props, reactifiedChildren));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;